import { InjectionToken } from '@angular/core';

export const TRANSLATION_PATH = new InjectionToken<string[]>(
  'Paths for translation file assets.'
);
